const { SingleSelectPrototype } = require("./prototypes");

function GenderType() {
  this.type = "gender";

  this.validate = ({ eligibility, answer }) => eligibility.includes(answer);
}
GenderType.prototype = SingleSelectPrototype;

module.exports = GenderType;
